import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Page } from '../../utils/ReactPdf';
/**
 * Simple wrapper around the react-pdf Page which maps the innerRef (passed by react-waypoint) prop to inputRef on the react-pdf Page
 * @param props
 * @returns {*}
 * @constructor
 */

export default function PageWrapper(props) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PageWithAlignedTextLayer, _extends({}, props, {
    inputRef: props.innerRef
  })));
} // Ugly !importants are necessary to fix ReactPdf's misaligned text layer on some PDFs,
// which applies inline styling of top: 50%, left: 50% and transform(-50%, -50%) which
// don't work as intended

var PageWithAlignedTextLayer = /*#__PURE__*/styled(Page).withConfig({
  displayName: "PageWrapper__PageWithAlignedTextLayer",
  componentId: "sc-1nnizk5-0"
})(["&&& div:first-of-type{top:0 !important;left:0 !important;transform:none !important;}"]);
PageWrapper.propTypes = {
  /**
   * The inner ref, we be ref to the outer most div for the Page
   */
  innerRef: PropTypes.func
};